PopOver = require 'views/lib/pop-over'
React = require 'react'
ProgressDisplayComponent = require 'views/enterprise/dashboard/bulk-actions/progress-component/display-component'

l = require 'lib/localize'
LOCALE_TEMPLATE_NAME = 'enterprise_dashboard_bulk_actions_progress_display'

module.exports = class BulkActionProgressDisplay

  constructor: (@element, @modelName, @enterpriseDisplayName, @total, @action) ->
    # Default properties
    @processed = 0
    @results = []
    @currentViewTitle = @_getLocalizedString([@action, 'running'])
    @modelLabel = @_getLocalizedString(['modelLabel'])

    @_showProgressDisplayPopover()

  incrementProcessed: ->
    @processed = @processed + 1
    @_showProgressDisplayPopover()

  done: (results) ->
    @results = results
    @currentViewTitle = @_getLocalizedString([@action, 'done'])
    @_showProgressDisplayPopover()

  _getLocalizedString: (key) ->
    l(['templates', LOCALE_TEMPLATE_NAME, key...])

  _showProgressDisplayPopover: ->
    PopOver.show
      alignRight: true
      elem: @element
      getViewTitle: => @currentViewTitle
      reactElement: React.createElement ProgressDisplayComponent, {
        @processed
        @total
        @modelLabel
        @modelName
        @results
        @enterpriseDisplayName
        onDoneClick: -> PopOver.hide()
        key: 'bulk-action-progress-display-component'
      }



// WEBPACK FOOTER //
// ./app/scripts/views/lib/bulk-action-progress-display.coffee